module.exports = __webpack_public_path__ + "img/BannerNew.d83ef66e.svg";